const baseURL = process.env.REACT_APP_BACKEND_URL;

export default baseURL;

export const endPoints = {
    //auth api
    login: 'api/Merchant/Login',

     verifyMerchantUser: 'api/Merchant/Login/VerifyMerchantUser', // For Forget Password email verification
    verifyOtp: 'api/Merchant/Login/VerifyMerchantUserOTP' ,// OTP verification

    //refresh token
    refreshToken: 'api/Merchant/Login/refresh',

    //profile Info
    getProfileInfo: (id) => `api/Merchant/Merchant/${id}`,

    //dashboard api
    // getDashboardInfo: (id) => `/api/Dashboard/${id}`,
    // getDashboardInfo: (id) => `api/Dashboard?merchantId=${id}`,
    getDashboardInfo: (merchantId) => `api/Dashboard?merchantId=${merchantId}`,


    //Dropdowns
    getDropdownUsers: 'api/v1/Dropdown/users',
    getDropdownPaymentMethod: 'api/Dropdown/paymentMethods',
    getDropdownTicketsTypes: 'api/Dropdown/ticketTypes',
    getDropdownTicketsStatus: 'api/Dropdown/ticketStatues',
    getDropdownMerchantUserRolesTypes: (id) => `api/Dropdown/merchant/roles/${id}`,

    //roles
    getallRoles: 'api/Merchant/Role',
    addRole: 'api/Merchant/Role',
    updateRole: 'api/Merchant/Role',
    getRoleById: (id) => `api/Merchant/Role/${id}`,
    deleteRole: (id) => `api/Merchant/Role/${id}`,

    //Permissions
    getallPermissions: 'api/Merchant/Permission',

    //Merchants Users
    getallMerchantUsers: 'api/Merchant/User',
    addMerchantUser: 'api/Merchant/User',
    updateMerchantUser: 'api/Merchant/User',
    getMerchantUserById: (id) => `api/Merchant/User/${id}`,
    deleteMerchantUser: (id) => `api/Merchant/User/${id}`,

    //Merchants Reports
    searchMerchantLiveReports: 'api/Merchant/Reports/GetAllTransactions',
    searchMerchantQRReports: 'api/Merchant/Reports/GetAllQRTransactions',
    searchMerchantArchivedReports: 'api/Merchant/Reports/GetAllArchivedTransactions',

    // Tickets Api
    getAllTicket: 'api/Ticket/getAll',
    createTicket: 'api/Ticket/create',
    getTicketById: (id) => `api/Ticket/${id}`,
    createTicketThread: 'api/Ticket/AddTicketThread',
    // Merchant Branding Image
    createMerchantBrandingImage: 'api/Merchant/MerchantBrandingImage/add',
    getMerchantBrandingImageId: (merchantId) => `api/Merchant/MerchantBrandingImage/get/${merchantId}`
};
